export enum ServiceType{
  FILSERVICE  = 'Filservice med rutning',
  WEBSERVICE  = 'Webservice med rutning',
}